<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page">
    <header><h1 class="rb-ob-title">{{ confirmed ? (isFa ? 'رزرو تأیید شد' : 'Booking confirmed') : (isFa ? 'وضعیت رزرو' : 'Booking status') }}</h1></header>
    <p v-if="needsLogin" class="rb-ob-status" role="status">{{ $t('intake.portal.needsLogin') }}</p>
    <p v-else-if="loading" class="rb-ob-status" role="status">{{ $t('intake.portal.loading') }}</p>
    <span v-if="confirmed" class="rb-success-mark" aria-hidden="true">✓</span>

    <ul class="rb-pay-summary" aria-label="Server-authoritative booking result">
      <li><span class="rb-pay-summary-k">{{ isFa ? 'وضعیت رزرو' : 'Booking status' }}</span><span class="rb-pay-summary-v">{{ clientMessage(status, lang) }}</span></li>
      <li><span class="rb-pay-summary-k">{{ isFa ? 'مبلغ پذیرفته‌شده' : 'Accepted amount' }}</span><span class="rb-pay-summary-v">{{ amountLabel }}</span></li>
      <li><span class="rb-pay-summary-k">{{ isFa ? 'کد رزرو' : 'Booking code' }}</span><span class="rb-pay-summary-v"><bdi>{{ bookingCode || '—' }}</bdi></span></li>
    </ul>

    <div class="rb-ob-status-panel"><p class="rb-match-outcome-body">{{ statusMessage }}</p></div>
    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" :disabled="loading" @click="bootstrap">{{ isFa ? 'بررسی دوبارهٔ وضعیت پرداخت' : 'Check payment status again' }}</button>
      <button v-if="confirmed" class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="prepare">{{ isFa ? 'ادامه' : 'Continue' }}</button>
      <router-link v-if="!loading && !confirmed" class="rb-ob-submit rb-ob-submit-secondary" :to="{name:'portalPayments',params:{lang}}">{{ isFa ? 'پیگیری در تاریخچهٔ پرداخت‌ها' : 'View payment history' }}</router-link>
      <router-link v-if="!loading && !confirmed" class="rb-ob-submit rb-ob-submit-secondary" :to="{name:'portalSessions',params:{lang}}">{{ isFa ? 'مشاهدهٔ جلسه‌ها' : 'View sessions' }}</router-link>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import {clientMessage,clientError} from '@/intake/clientMessages'
import {bookingResultCode, bookingResultCurrency, bookingResultStatus, fetchActiveCare, fetchCareConsent, formatMoneyAmount, hasAuthToken, paymentResultAmount, resolvePaymentResult} from '@/intake/portalApi'

export default {
  name: 'MatchPaySuccessStep',
  data() { return {loading: false, needsLogin: false, result: null, error: '', preparationTarget: null} },
  computed: {
    lang() { return this.$route.params.lang || 'fa' }, isFa() { return this.lang === 'fa' },
    status() { return bookingResultStatus(this.result) }, confirmed() { return this.status === 'CONFIRMED' },
    bookingCode() { return bookingResultCode(this.result) },
    amount() { return paymentResultAmount(this.result) }, currency() { return bookingResultCurrency(this.result) || 'toman' },
    amountLabel() { return this.amount == null ? '—' : formatMoneyAmount(this.amount, this.currency, this.lang) },
    statusMessage() {
      if (this.confirmed) return this.isFa ? 'جلسهٔ تو با موفقیت رزرو شد. برای آمادگی جلسه ادامه بده.' : 'Your session is booked. Continue to prepare for it.'
      if (['PROCESSING','PAYMENT_LATE','MANUAL_SCHEDULING_REQUIRED','AWAITING_PAYMENT','PAYMENT_FAILED','CANCELLED','NONE','HELD','HOLD_ACTIVE'].includes(this.status)) return clientMessage(this.status, this.lang)
      return this.isFa ? 'وضعیت این رزرو دریافت نشد. از تاریخچهٔ پرداخت‌ها یا پشتیبانی پیگیری کن؛ اگر مبلغ کسر شده، دوباره پرداخت نکن.' : 'This booking status could not be loaded. Use payment history or support; if you were charged, do not pay again.'
    },
  },
  mounted() { this.bootstrap() },
  methods: {clientMessage,
    async bootstrap() {
      if (this.loading) return
      this.result = null
      this.preparationTarget = null
      this.error = ''
      this.needsLogin = !hasAuthToken()
      if (this.needsLogin) return
      this.loading = true
      try {
        this.result = await resolvePaymentResult(this.$route.query || {})
        if (!this.confirmed) return
        const sessionId = this.result && this.result.booking && this.result.booking.user_session_id
        if (!Number.isSafeInteger(Number(sessionId)) || Number(sessionId) <= 0) return
        // Only the owned, confirmed first session can lead straight to its consent.
        // A context lookup failure must not turn a confirmed payment into a failure.
        try {
          const episode = await fetchActiveCare({userSessionId: String(sessionId)})
          if (!episode || episode.state !== 'PREPARING' || String(episode.first_user_session_id) !== String(sessionId)) return
          const consent = await fetchCareConsent(episode.id)
          if (consent && consent.state !== 'ACCEPTED') {
            this.preparationTarget = {name: 'intakeConsent', params: {lang: this.lang}, query: {id: String(sessionId)}}
          }
        } catch (_) { /* The dashboard can resolve any remaining preparation steps. */ }
      } catch (e) {
        this.error = clientError(e, this.lang)
      } finally {
        this.loading = false
      }
    },
    prepare() {
      if (!this.confirmed || this.loading || this.needsLogin) return
      this.$router.push(this.preparationTarget || {name: 'portalHome', params: {lang: this.lang}})
    },
  },
}
</script>
